<template>
  <div class="cmd-overlay" v-if="aberto" @click.self="fechar">
    <div class="cmd-painel">
      <div class="cmd-input">
        <i class="bi bi-search"></i>
        <input
          ref="input"
          v-model="termo"
          type="text"
          :placeholder="$t('buscar_relatorio')"
          @keydown.esc="fechar"
          @keydown.enter="selecionarPrimeiro"
        >
        <kbd @click="fechar">esc</kbd>
      </div>

      <div class="cmd-lista" v-if="termo.trim()">
        <button
          class="cmd-item"
          v-for="(link, i) in resultados"
          :key="i"
          @click="abrir(link)"
        >
          <i :class="'bi ' + (link.ic_link || 'bi-bar-chart')"></i>
          <span class="cmd-item-texto">
            <strong>{{ link.ds_link }}</strong>
            <small>{{ link.ds_nome }}</small>
          </span>
        </button>

        <div class="cmd-vazio" v-if="!resultados.length">
          {{$t('nenhum_relatorio_encontrado')}}
        </div>
      </div>

      <div class="cmd-lista" v-else-if="recentes.length">
        <span class="cmd-label">{{$t('acessados_recentemente')}}</span>
        <button
          class="cmd-item"
          v-for="(link, i) in recentes"
          :key="i"
          @click="abrir(link)"
        >
          <i :class="'bi ' + (link.ic_link || 'bi-bar-chart')"></i>
          <span class="cmd-item-texto">
            <strong>{{ link.ds_link }}</strong>
            <small>{{ link.ds_nome }}</small>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { flattenMenus, buscarRelatorios } from '@/utils/relatorios'

export default {
  name: 'CommandPalette',
  data() {
    return {
      termo: ''
    }
  },
  computed: {
    aberto() {
      return this.$store.getters['ui/comandoAberto']
    },
    recentes() {
      return this.$store.getters['abas/recentes']
    },
    todosOsLinks() {
      return flattenMenus(this.$store.getters['busca/getMenus'])
    },
    resultados() {
      return buscarRelatorios(this.todosOsLinks, this.termo).slice(0, 8)
    }
  },
  watch: {
    aberto(valor) {
      if (valor) {
        this.termo = ''
        this.$nextTick(() => {
          if (this.$refs.input) this.$refs.input.focus()
        })
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.onKeydownGlobal)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydownGlobal)
  },
  methods: {
    onKeydownGlobal(evento) {
      const teclaK = evento.key === 'k' || evento.key === 'K'
      if ((evento.ctrlKey || evento.metaKey) && teclaK) {
        evento.preventDefault()
        this.$store.dispatch('ui/abrirComando')
      }
    },
    fechar() {
      this.$store.dispatch('ui/fecharComando')
    },
    abrir(link) {
      this.$store.dispatch('abas/abrirRelatorio', link)
      this.fechar()
    },
    selecionarPrimeiro() {
      if (this.resultados.length) {
        this.abrir(this.resultados[0])
      }
    }
  }
}
</script>

<style scoped>
.cmd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12vh;
  z-index: 100000;
}

.cmd-painel {
  width: 90%;
  max-width: 520px;
  background: var(--rd-bg-1);
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-lg);
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

.cmd-input {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--rd-border);
  color: var(--rd-text-3);
}

.cmd-input input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--rd-text-1);
  font-size: 14px;
}

.cmd-input kbd {
  font-size: 11px;
  color: var(--rd-text-3);
  border: 1px solid var(--rd-border-strong);
  border-radius: 5px;
  padding: 2px 6px;
  cursor: pointer;
}

.cmd-lista {
  max-height: 320px;
  overflow-y: auto;
  padding: 8px;
}

.cmd-label {
  display: block;
  color: var(--rd-text-3);
  font-size: 11px;
  letter-spacing: 0.05em;
  padding: 6px 8px 4px;
}

.cmd-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-radius: var(--rd-radius-sm);
  padding: 9px 10px;
  color: var(--rd-text-1);
  cursor: pointer;
}

.cmd-item:hover {
  background: var(--rd-hover);
}

.cmd-item i {
  color: var(--rd-text-3);
  font-size: 15px;
  width: 18px;
  text-align: center;
}

.cmd-item-texto {
  display: flex;
  flex-direction: column;
}

.cmd-item-texto strong {
  font-size: 13px;
  font-weight: 500;
}

.cmd-item-texto small {
  color: var(--rd-text-3);
  font-size: 11px;
}

.cmd-vazio {
  padding: 16px;
  text-align: center;
  color: var(--rd-text-3);
  font-size: 13px;
}
</style>
